import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';

const storeAgnosticPages = [contentTypes.CfHowItWorksPage];

const isStoreAgnosticPage = (contentType) => storeAgnosticPages.includes(contentType);

export default isStoreAgnosticPage;
